var _ellipse, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoinvoicesfound({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 91,
    viewBox: "0 0 102 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.05,
    cx: 71.5,
    cy: 30,
    rx: 30.5,
    ry: 30,
    fill: "#5070DE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.115 82.2705L55.9353 79.9993C57.5317 78.0012 60.9254 78.1625 62.2717 80.2955C63.8945 82.8663 67.9038 82.3561 69.0164 79.9927C69.0756 79.8709 68.9308 80.177 69.0526 79.1138C69.1776 78.0506 69.125 77.807 69.0196 77.3231L62.6931 47.4348C61.0999 39.9199 60.3066 36.1641 57.5679 33.9554C54.8391 31.75 50.9714 31.75 43.2525 31.75H35.7574C28.0318 31.75 24.1707 31.75 21.4353 33.9554C18.6966 36.1608 17.9034 39.9199 16.3102 47.4315L9.98032 77.3198C9.87827 77.807 9.82561 78.0506 9.9474 79.1138C10.0725 80.177 9.93094 79.8709 9.9869 79.9927C11.0995 82.3561 15.1087 82.8696 16.7315 80.2988C18.0811 78.1625 21.4715 78.0012 23.068 79.9993L24.885 82.2705C27.176 85.1342 31.9621 85.1342 34.2498 82.2705L34.5361 81.9117C36.9654 78.8768 42.0411 78.8768 44.4704 81.9117L44.7568 82.2705C47.0478 85.1342 51.8306 85.1342 54.1216 82.2705",
    stroke: "#5070DE",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.17359 43.2715C6.24797 41.2702 6.61005 38.6928 6.61005 32.251C6.61005 25.8092 6.61005 22.5867 8.53897 20.5853C10.4646 18.584 13.5621 18.584 19.7668 18.584H59.2339C65.4354 18.584 68.5362 18.584 70.4651 20.5853C72.394 22.5867 72.3907 25.8092 72.3907 32.251C72.3907 38.6928 72.7528 41.2702 70.8239 43.2715M39.5004 44.9173H29.6254M46.0837 58.084H26.3337",
    stroke: "#5070DE",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoinvoicesfound);
export default __webpack_public_path__ + "static/media/noinvoicesfound.a75cf76ecddbd16cda33f4c0ff594b95.svg";
export { ForwardRef as ReactComponent };